import objectOf from './objectOf';

// ----------------------------------------------------------------------------

const UNSAFE_KEYS = new Set(['__proto__', 'constructor', 'prototype']);

function extend(...args: any[]): Record<string, any> {
    const extended: Record<string, any> = {};
    let deep = false;
    let index = 0;

    // Detect if first argument is boolean
    if (typeof args[0] === 'boolean') {
        deep = args[0];
        index = 1;
    }

    // Merge function
    const merge = (obj: Record<string, any>): void => {
        for (const key in obj) {
            if (!Object.hasOwn(obj, key) || UNSAFE_KEYS.has(key)) {
                continue;
            }

            const val = obj[key];

            if (deep && objectOf(val) === 'Object' && objectOf(extended[key]) === 'Object') {
                extended[key] = extend(true, extended[key], val);
            } else {
                extended[key] = val;
            }
        }
    };

    // Merge all objects into extended
    for (; index < args.length; index++) {
        const obj = args[index];

        if (objectOf(obj) === 'Object') {
            merge(obj);
        }
    }

    return extended;
}

// ----------------------------------------------------------------------------

export default extend;
